import { Plus } from '@phosphor-icons/react';
import { cloneElement, ReactElement, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ILog } from 'bom/types';
import { Button, IButtonProps } from 'core/components';
import { useAgGridClientTableContext } from 'core/states';
import { Color } from 'theme/enums';

import { UpsertLogs } from './UpsertLogs';

interface IProps extends IButtonProps {
  jobId: number;
  buttonElement?: ReactElement;
}

export const AddLogButton = ({ jobId, buttonElement, ...rest }: IProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const { t } = useTranslation();

  const { updateRows } = useAgGridClientTableContext();

  const onSubmitSuccess = async (logs: ILog[]) => {
    if (logs?.length) {
      updateRows({ add: logs });
    }
  };

  const handleOnClose = () => setIsOpen(false);

  const button = useMemo(() => {
    if (buttonElement) {
      return cloneElement(buttonElement, {
        onClick: () => setIsOpen(true),
      });
    }

    return (
      <Button
        text={t('buttonLabelAddLog')}
        color={Color.PRIMARY}
        startDecorator={<Plus />}
        onClick={() => setIsOpen(true)}
        {...rest}
      />
    );
  }, [buttonElement, rest, t]);

  return (
    <>
      {button}

      <UpsertLogs
        isOpen={isOpen}
        onClose={handleOnClose}
        jobId={jobId}
        onSubmitSuccess={onSubmitSuccess}
      />
    </>
  );
};
